import * as React from "react";
import { Redirect } from "react-router-dom";

const GotoExchanges: React.FC = () => <Redirect to="/exchanges" />;

export default GotoExchanges;
